import { render } from "./TerpelConfig.vue?vue&type=template&id=6ac6e44c"
const script = {}

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__